import apiClient from './client';

export const companiesApi = {
  searchCompanies: async (params = {}) => {
    const response = await apiClient.get('/api/v1/companies', { params });
    return response.data;
  },

  getCompanyDetail: async (pitchbookId) => {
    const response = await apiClient.get(`/api/v1/companies/${pitchbookId}`);
    return response.data;
  },

  getCompanyFullDetail: async (pitchbookId) => {
    const response = await apiClient.get('/api/v1/companies/full', {
      params: { search: pitchbookId, limit: 1 }
    });
    if (!response.data || response.data.length === 0) {
      throw new Error(`No full data found for company ${pitchbookId}`);
    }
    return response.data[0];
  },

  getCompaniesFull: async (params = {}) => {
    const response = await apiClient.get('/api/v1/companies/full', { params });
    return response.data;
  },
};
